<template>
  <div style="overflow: visible;" class="homes_item homes_item-nodes">
    <p class="nd_p_text14 nd_font_weight600 mb-3">{{ $t('myNote') }}</p>
    <div style=" overflow-y: auto; height: 400px">
      <div style="" v-for="item in nodeList" :key="item.id">
        <div style="cursor: pointer; display: block" @click="isOpen(item)" class="nd_status bg-white mb-3">
          <div class="d-flex" style="align-items: center; gap: 4px;">
            <svg style="flex-shrink: 0" v-if="item.statusType === 'ALERT'" xmlns="http://www.w3.org/2000/svg" width="16"
              height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 4.29333V6.51334" stroke="#13C55E" stroke-miterlimit="10" stroke-linecap="round" />
              <path
                d="M8.01333 1.33334C5.55999 1.33334 3.57333 3.32001 3.57333 5.77334V7.17334C3.57333 7.62668 3.38666 8.30668 3.15333 8.69334L2.30666 10.1067C1.78666 10.98 2.14666 11.9533 3.10666 12.2733C6.29333 13.3333 9.73999 13.3333 12.9267 12.2733C13.8267 11.9733 14.2133 10.92 13.7267 10.1067L12.88 8.69334C12.6467 8.30668 12.46 7.62001 12.46 7.17334V5.77334C12.4533 3.33334 10.4533 1.33334 8.01333 1.33334Z"
                stroke="#13C55E" stroke-miterlimit="10" stroke-linecap="round" />
              <path
                d="M10.22 12.5467C10.22 13.7667 9.22 14.7667 8 14.7667C7.39333 14.7667 6.83333 14.5133 6.43333 14.1133C6.03333 13.7133 5.78 13.1533 5.78 12.5467"
                stroke="#13C55E" stroke-miterlimit="10" />
            </svg>
            <svg style="flex-shrink: 0" v-else-if="item.statusType === 'CONFERENCE'" xmlns="http://www.w3.org/2000/svg"
              width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M14.6667 7.92665V8.51998C14.6667 10.8933 14.0734 11.48 11.7067 11.48H4.29337C1.92671 11.48 1.33337 10.8866 1.33337 8.51998V4.29331C1.33337 1.92665 1.92671 1.33331 4.29337 1.33331H5.33337"
                stroke="#0092FF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.99997 11.48V14.6666" stroke="#0092FF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M1.33337 8.66663H14.6667" stroke="#0092FF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4.99997 14.6666H11" stroke="#0092FF" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M11.9067 6.24669H8.73335C7.81335 6.24669 7.50668 5.63336 7.50668 5.02003V2.67336C7.50668 1.94003 8.10668 1.34003 8.84002 1.34003H11.9067C12.5867 1.34003 13.1334 1.88669 13.1334 2.56669V5.02003C13.1334 5.70003 12.5867 6.24669 11.9067 6.24669Z"
                stroke="#0092FF" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M13.94 5.28L13.1333 4.71334V2.87334L13.94 2.30667C14.34 2.03334 14.6667 2.2 14.6667 2.68667V4.90667C14.6667 5.39334 14.34 5.56 13.94 5.28Z"
                stroke="#0092FF" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg style="flex-shrink: 0" v-else-if="item.statusType === 'BIRTHDAY'" xmlns="http://www.w3.org/2000/svg"
              width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1.33333 14.6667H14.6667" stroke="#BB6CDB" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M2.07333 14.6667V8.66666C2.07333 7.55999 3.06667 6.66666 4.29333 6.66666H11.7C12.9267 6.66666 13.92 7.55999 13.92 8.66666V14.6667"
                stroke="#BB6CDB" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M3.70667 6.66668V4.78001C3.70667 3.98001 4.42667 3.33334 5.32 3.33334H10.6867C11.5733 3.33334 12.2933 3.98001 12.2933 4.78001V6.66668"
                stroke="#BB6CDB" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M2.35333 9.32001L2.6 9.32667C3.09333 9.33334 3.48667 9.73334 3.48667 10.2267V10.4467C3.48667 10.94 3.88667 11.3467 4.38667 11.3467C4.88 11.3467 5.28667 10.9467 5.28667 10.4467V10.24C5.28667 9.74667 5.68667 9.34001 6.18667 9.34001C6.68 9.34001 7.08667 9.74001 7.08667 10.24V10.4467C7.08667 10.94 7.48667 11.3467 7.98667 11.3467C8.48 11.3467 8.88667 10.9467 8.88667 10.4467V10.24C8.88667 9.74667 9.28667 9.34001 9.78667 9.34001C10.28 9.34001 10.6867 9.74001 10.6867 10.24V10.4467C10.6867 10.94 11.0867 11.3467 11.5867 11.3467C12.08 11.3467 12.4867 10.9467 12.4867 10.4467V10.24C12.4867 9.74667 12.8867 9.34001 13.3867 9.34001H13.6867"
                stroke="#BB6CDB" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.33333 3.33333V2" stroke="#BB6CDB" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10.6667 3.33333V2" stroke="#BB6CDB" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M8 3.33334V1.33334" stroke="#BB6CDB" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg style="flex-shrink: 0" v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16"
              viewBox="0 0 16 16" fill="none">
              <path d="M5.33333 1.33334V3.33334" stroke="#FF4D00" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M10.6667 1.33334V3.33334" stroke="#FF4D00" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M10.6667 2.33334C12.8867 2.45334 14 3.30001 14 6.43334V10.5533C14 13.3 13.3333 14.6733 10 14.6733H6C2.66667 14.6733 2 13.3 2 10.5533V6.43334C2 3.30001 3.11333 2.46001 5.33333 2.33334H10.6667Z"
                stroke="#FF4D00" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.8333 11.7333H2.16667" stroke="#FF4D00" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M7.99999 5.5C7.17999 5.5 6.48666 5.94667 6.48666 6.81333C6.48666 7.22667 6.67999 7.54 6.97333 7.74C6.56666 7.98 6.33333 8.36667 6.33333 8.82C6.33333 9.64667 6.96666 10.16 7.99999 10.16C9.02666 10.16 9.66666 9.64667 9.66666 8.82C9.66666 8.36667 9.43333 7.97333 9.01999 7.74C9.31999 7.53333 9.50666 7.22667 9.50666 6.81333C9.50666 5.94667 8.81999 5.5 7.99999 5.5ZM7.99999 7.39333C7.65333 7.39333 7.4 7.18667 7.4 6.86C7.4 6.52667 7.65333 6.33333 7.99999 6.33333C8.34666 6.33333 8.59999 6.52667 8.59999 6.86C8.59999 7.18667 8.34666 7.39333 7.99999 7.39333ZM7.99999 9.33333C7.55999 9.33333 7.23999 9.11333 7.23999 8.71333C7.23999 8.31333 7.55999 8.1 7.99999 8.1C8.43999 8.1 8.75999 8.32 8.75999 8.71333C8.75999 9.11333 8.43999 9.33333 7.99999 9.33333Z"
                fill="#FF4D00" />
            </svg>
            <p style="font-weight: 600; font-size: 16px; word-break: break-word"
              class="nd_p_text14 pl-2 nd_font_weight500 nd_text_black nd_font_weight500">{{ item.title }} </p>
          </div>
          <p style="text-align: end;" class="nd_p_text14 mt-2 pl-2 nd_font_weight500 nd_text_black nd_font_weight500">
            <span style=" background: #F0D000; color: #FFFFFF; padding: 5px; border-radius: 6px; font-size: 12px">
              {{ item.to ? item.to.slice(8, 10) : "" }}.{{ item.to ? item.to.slice(5, 7) : "" }} &nbsp; {{ item.to ?
                item.to.slice(11, 16) : "" }} </span>
          </p>
        </div>
        <transition name="fade">
          <div class="homes_item-modal edit-modal " v-if="item.id === openItemId">
            <div class="d-flex justify-content-end pr-2 pt-1">
              <button @click="openItemId = false;" data-bs-dismiss="modal" type="button" data-dismiss="modal"
                aria-label="Close" class="btn-close border-0  bg-transparent"><span
                  style="font-size: 22px; color: #7A889B; font-weight: 200; position: absolute; top: 10px;right: 10px;"
                  aria-hidden="true">×</span></button>
            </div>
            <div class="text-dark ">
              <div class="modal-body modal-body-note  homes_item-modal-content text-dark ">
                <h6 style="color: #48545D; font-weight: 700; font-size: 24px">
                  {{ $t("editNote") }}
                </h6>
                <div class="form-group " style="margin-top: 32px">
                  <input style="background: rgb(250, 251, 252)" class="form-control mb-3" v-model="postNodes.title"
                    type="text" :placeholder="$t('noteName')" />
                  <textarea class="form-control" v-model="postNodes.description"
                    style="background: #FAFBFC; border: 1px solid #DFE2E9; border-radius: 6px; "
                    :placeholder="$t('description')"></textarea>

                  <div class="d-flex pt-3 pb-3 " style="gap: 10px">
                    <datepicker v-bind="{ 'disabled-dates': { to: oneDayBack } }" v-model.trim="postNodes.to.date"
                      style="background: rgb(250, 251, 252); width: 250px" bootstrap-styling
                      :placeholder="$t('deadline')" format="d.MM.yyyy"></datepicker>
                    <input style="background: rgb(250, 251, 252); width: 150px" v-model="postNodes.to.time" required
                      class="form-control" type="time" />
                  </div>
                  <div>
                    <select v-model="postNodes.statusType"
                      style="width: 100%; color: #A2A5B9; padding: 10px; border-radius: 6px;border: 1px solid #DFE2E9;background: #FAFBFC;"
                      aria-label="Default select example">
                      <option style="background: #fff; color: #000000; padding: 10px" :key="item.name"
                        v-for="item in selectedStatusNote" :value="item.name">{{ $t(item.name) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div style="gap: 16px" class="d-flex justify-content-end">
                <button @click="deleteNodeId(item)" style="background: #E8503D " class="btn btn-danger">{{
                  $t('delete')
                }}
                </button>
                <button @click="editNode(item)" style="background: #0096B2; border: none " class="btn btn-secondary">
                  {{ $t('save') }}
                </button>
              </div>
            </div>

          </div>
        </transition>
      </div>
    </div>
    <button @click="EmptyData" type="button" class="btn nd_btn_add mt-2" data-bs-toggle="modal"
      data-bs-target="#staticBackdrop">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M11.4001 4.4C11.4001 3.6268 10.7733 3 10.0001 3C9.22689 3 8.60009 3.6268 8.60009 4.4V8.60001H4.4C3.6268 8.60001 3 9.22681 3 10C3 10.7732 3.6268 11.4 4.4 11.4H8.60008V15.6C8.60008 16.3732 9.22689 17 10.0001 17C10.7733 17 11.4001 16.3732 11.4001 15.6V11.4H15.6C16.3732 11.4 17 10.7732 17 10C17 9.22681 16.3732 8.60001 15.6 8.60001H11.4001V4.4Z"
          fill="#171F26" fill-opacity="0.6" />
      </svg>
    </button>
    <transition name="fade">
      <div class="modal" id="staticBackdrop" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content border-0" style="border-radius: 18px">
            <div class="modal-body modal-body-node text-dark create-modal">
              <div class="d-flex justify-content-end ">
                <button data-bs-dismiss="modal" type="button" data-dismiss="modal" aria-label="Close"
                  class="btn-close border-0  bg-transparent"><span
                    style="font-size: 22px; color: #7A889B; font-weight: 200; position: absolute; top: 10px;right: 10px;"
                    aria-hidden="true">×</span></button>
              </div>
              <h6 style="color: #48545D; font-weight: 700; font-size: 24px">
                {{ $t('createNote') }}
              </h6>
              <form @submit.prevent="submit">
                <div class="form-group" style="padding-top: 32px;">
                  <input required style="background: rgb(250, 251, 252)" class="form-control mb-3" type="text"
                    :placeholder="$t('noteName')" :class="{ 'is-invalid': $v.model.title.$error }"
                    v-model="$v.model.title.$model">

                  <textarea required class="form-control" v-model="postNodes.description"
                    style="background: #FAFBFC; border: 1px solid #DFE2E9; border-radius: 6px; "
                    :placeholder="$t('description')"></textarea>

                  <div class="d-flex pt-3 pb-3 align-items-end" style="gap: 10px">
                    <div>
                      <label style="font-size: 14px">{{ $t('deadline') }}</label>
                      <datepicker v-bind="{ 'disabled-dates': { to: oneDayBack } }"
                        v-model.trim="$v.model.to.date.$model" style="background: rgb(250, 251, 252);"
                        :class="{ 'is-invalid': $v.model.to.date.$error }" bootstrap-styling
                        :placeholder="$t('deadline')" format="d.MM.yyyy"></datepicker>
                    </div>
                    <input style="background: rgb(250, 251, 252); width: 140px" v-model="$v.model.to.time.$model"
                      required class="form-control" :class="{ 'is-invalid': $v.model.to.time.$error }" type="time" />
                  </div>
                  <div>
                    <select v-model="postNodes.statusType"
                      style="width: 100%; color: #A2A5B9; padding: 10px; border-radius: 6px;border: 1px solid #DFE2E9;background: #FAFBFC;"
                      class="form-select" aria-label="Default select example">
                      <option :disabled="disabled" value="null" selected
                        style="background: #fff; color: #A2A5B9; padding: 10px">{{ $t('status') }}
                      </option>
                      <option style="background: #fff; color: #000000; padding: 10px" :key="`optionkey-${item.name}`"
                        v-for="item in selectedStatusNote" :value="item.name">{{ $t(item.name) }}
                      </option>
                    </select>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button @click.prevent="submit" class="btn-close btn az_base_btn btn-primary  mt-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        style="margin-right: 8px;">
                        <path
                          d="M7.99967 1.33331C4.31967 1.33331 1.33301 4.31998 1.33301 7.99998C1.33301 11.68 4.31967 14.6666 7.99967 14.6666C11.6797 14.6666 14.6663 11.68 14.6663 7.99998C14.6663 4.31998 11.6797 1.33331 7.99967 1.33331ZM11.333 8.66665H8.66634V11.3333H7.33301V8.66665H4.66634V7.33331H7.33301V4.66665H8.66634V7.33331H11.333V8.66665Z"
                          fill="white"></path>
                      </svg>
                      {{ $t('save') }}
                    </button>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import i18n from "@/plugins/vue-i18n-config";
import Datepicker from 'vuejs-datepicker';
import { required } from "vuelidate/lib/validators";
import FormService from "@/services/FormService";

export default {
  name: 'HomeNodes',
  data() {
    return {
      disabled: true,
      openItemId: null,
      selectedStatusNote: [
        {
          name: 'BIRTHDAY',
        },
        {
          name: 'ALERT'
        },
        {
          name: 'EVENT'
        },
        {
          name: 'CONFERENCE'
        },
      ],
      openModal: false,
      nodeList: [],
      model: new FormService({
        title: null,
        to: {
          date: null,
          time: null
        },
      }),
      postNodes: {
        to: {
          date: '',
          time: ''
        },
        description: '',
        title: '',
        statusType: '',
      },
    };
  },
  components: {
    Datepicker,
  },
  computed: {
    oneDayBack() {
      const date = new Date()
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      return date
    },
  },
  validations: {
    model: {
      title: {
        required,
      },
      to: {
        date: {
          required
        },
        time: {
          required
        }
      }
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.postNodeId()
    },
    extractDateTime(component, mode) {
      const combinedDateTime = component;

      if (mode === 'date') {
        return combinedDateTime.split('T')[0];
      } else if (mode === 'time') {
        return combinedDateTime.split('T')[1];
      } else {
        return null;
      }
    },
    EmptyData() {
      this.openItemId = false
      this.model = {
        to: {
          date: '',
          time: '',
        },
        description: '',
        title: '',
        statusType: null,
      }
      this.$v.$reset()
      this.postNodes.description = ""
      this.postNodes = {
        to: {
          date: '',
          time: '',
        },
        description: '',
        title: '',
        statusType: null,
      };
    },
    editNode(item) {
      let conBinedDateToTime = "";

      if (this.postNodes.to.date && this.postNodes.to.time) {
        conBinedDateToTime = `${this.postNodes.to.date ? this.$moment(this.postNodes.to.date).format('YYYY-MM-DD') : ""} ${this.postNodes.to.time}`
      }
      this.postNodes.id = item.id;

      this.$api
        .put('/notes', { ...this.postNodes, to: conBinedDateToTime })
        .then(() => {
          this.openItemId = false;
          this.$notification.success(this.$t('SuccessfullyCreated'));
          setTimeout(() => {
            this.getAllNodes()
          }, 400)

        }).catch(error => {
          this.$notification.error(error.response.data.error_message.title)
        })
    },
    isOpen(item) {
      if (this.openItemId === item.id) {
        this.openItemId = null;
      } else {
        this.openItemId = item.id;
      }
      if (item.id) {
        this.postNodes.title = item.title;
        this.postNodes.description = item.description;
        this.postNodes.statusType = item.statusType;

        if (item.to) {
          this.postNodes.to.date = this.extractDateTime(item.to, 'date')
          this.postNodes.to.time = this.extractDateTime(item.to, 'time')
        }

      } else {
        this.openItemId = null;
      }
    },
    getAllNodes() {
      this.$api
        .get('notes',)
        .then(response => {
          this.nodeList = response.data.data;
        });
    },
    deleteNodeId(item) {

      this.$api.delete('notes/' + item.id)
        .then(() => {
          this.nodeList = this.nodeList.filter(existingItem => existingItem.id !== item.id);

          this.$notification.success(i18n.t('successfullyDeleted'));
        })
        .catch(() => {
          this.$notification.error(this.$t('errorDeleting'));
        });

    },
    postNodeId() {
      // eslint-disable-next-line no-undef
      $("#staticBackdrop").modal('hide');
      const apiRequestObject = {
        ...this.postNodes,
        to: null,
      };

      apiRequestObject.title = this.model.title

      if (this.model.to.date && this.model.to.time) {
        const conBinedDateToTime = `${this.model.to.date ? this.$moment(this.model.to.date).format('YYYY-MM-DD') : ''} ${this.model.to.time}`;
        apiRequestObject.to = conBinedDateToTime
      }
      this.$api
        .post('notes', apiRequestObject)
        .then(() => {
          setTimeout(() => {
            this.getAllNodes();
          }, 300)
          this.$notification.success(this.$t('SuccessfullyCreated'));
        }).catch(error => {
          this.$notification.error(error.response.data.error_message.title);
        });
    },
  },
  mounted() {
    this.getAllNodes();
  },
}
</script>

<style lang="css" scoped>
.edit-modal {
  right: 340px;
  width: 410px;
  padding: 18px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
}

.create-modal {
  position: fixed;
  background: white;
  right: 350px;
  border-radius: 16px;
  width: 400px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
}

@media (max-width:1410px) {
  .create-modal {
    left: -280px
  }

  .edit-modal {
    left: -280px;
  }
}

@media (max-width:1050px) {
  .create-modal {
    top: 0 !important;
  }

  .edit-modal {
    top: 0 !important;
  }
}

@media (max-width:768px) {
  .create-modal {
    max-width: 350px;
    top: 30px !important;
    left: 5%;
  }

  .edit-modal {
    max-width: 350px;
    top: 30px !important;
    left: 5%;
  }

  .az_base_btn {
    margin-bottom: 0 !important;
    height: auto;
    padding: 5px 10px;
  }
}

@media (max-width: 400px) {
  .create-modal {
    width: 100%;
    left: 0;
  }

  .edit-modal {
    width: 100%;
    left: 0;
  }

  .form-group {
    padding-top: 10px !important;
    margin-bottom: 0 !important;
    margin-top: 10px !important;
  }
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-leave-active {
  transition: opacity 0.5s;

}

.fade-enter {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}
</style>
